import { TokenService } from './Services/Token.service';
import { SharedModule } from './ShareModule/ShareModule';
import { BrowserModule } from '@angular/platform-browser';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './Home/Home.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';

import { FormControl, FormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { HeaderComponent } from './Component/header/header.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { UnauthorizedInterceptor } from './Service/UnauthorizedInterceptor';
import { InplaceModule } from 'primeng/inplace';
import { InputTextModule } from 'primeng/inputtext';
@NgModule({
  declarations: [AppComponent, HomeComponent, HeaderComponent, ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatButtonToggleModule,
    MatIconModule,
    MatTooltipModule,
    SharedModule,
    MatSnackBarModule,
    InplaceModule,
    InputTextModule,

    SharedModule.forRoot(),

  ],
  providers: [TokenService,
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true }
  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
